import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Body2, Header5 } from "@iventis/styles/src/components/texts";
import { borderRadius, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { IconButton } from "@mui/material";
import React from "react";

type PositionMapOverlayProps = {
    title: string;
    text: string;
    onClose: () => void;
};

export const PositionMapOverlay: React.FunctionComponent<PositionMapOverlayProps> = ({ title, text, onClose }) => (
    <OverlayRoot data-testid="position-map-overlay">
        <FontAwesomeIcon icon={["fas", "circle-info"]} size="2x" />
        <OverlayTextContainer>
            <Header5>{title}</Header5>
            <Body2>{text}</Body2>
        </OverlayTextContainer>
        <OverlayCloseButton data-testid="position-map-overlay-close" onClick={onClose} size="small" aria-label="Close">
            <FontAwesomeIcon icon={["far", "xmark"]} />
        </OverlayCloseButton>
    </OverlayRoot>
);

const OverlayRoot = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 300px;
    padding: 20px 24px;
    background-color: ${({ theme }: { theme: Theme }) => theme.shades.five};
    border-radius: ${borderRadius.standard};
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    z-index: 1;
    pointer-events: auto;

    > svg {
        color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focus};
        flex-shrink: 0;
    }
`;

const OverlayTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const OverlayCloseButton = styled(IconButton)`
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 14px;
    color: ${({ theme }: { theme: Theme }) => theme.shades.two};
`;
